<main class="ic-page"> 
    <header class="payment__header">
        <h1 class="payment__header--title">{{ content.title }}</h1>
      </header>
    @if(waitingForData) {
        <div class="payment__spinner">
            <app-loaders [type]="'spinner'" [positionRelative]="true"></app-loaders>
        </div>
        }
    @if(this.payment) {
    <app-peu-table #table id="table" [payment]="payment"></app-peu-table>
    <app-choose-payment-method [showIcTerms]="false" [onlyBlik]="false"
        (submitPaymentMethod)="onSubmit($event)"></app-choose-payment-method>
    }

    <app-loaders fullScreen="true" [loadingText]="content.loaderText" [type]="'splash'"
        *ngIf="splashEnabled"></app-loaders>
</main>